const Friends =()=>{
 return(
    <div>
        <h2>Friends</h2>
    </div>
 )
}
export default Friends;